/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const removeCustomerKnownNumberBodyExpectedCustomerVersionExclusiveMin = 0;
export const removeCustomerKnownNumberBodyExpectedCustomerVersionMax = 9007199254740991;

export const RemoveCustomerKnownNumberBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(removeCustomerKnownNumberBodyExpectedCustomerVersionExclusiveMin)
    .max(removeCustomerKnownNumberBodyExpectedCustomerVersionMax),
});

export type RemoveCustomerKnownNumberBody = zod.input<typeof RemoveCustomerKnownNumberBody>;
export type RemoveCustomerKnownNumberBodyOutput = zod.output<typeof RemoveCustomerKnownNumberBody>;
